<template>
    <div>
        <lemon-imui
            :user='getCurrentUser'
            ref='imUi'
            width='100%'
            avatar-cricle
            :contextmenu='chatUi.contextMenu'
            :contact-contextmenu='chatUi.contactContextMenu'
            @change-menu='handleChatMenuChange'
            @change-contact='handleChangeContact'
            @pull-messages='handlePullMessages'
            @message-click='handleMessageClick'
            @menu-avatar-click='handleMenuAvatarClick'
            @send='handleMsgSend'
        >
            <template #message-side='contact'>
                <div style='max-width: 310px;' v-if='contact.isGroup && contact.info && contact.info.data'
                     class='slot-group'>
                    <el-card shadow='never' class='box-card'>
                        <div slot='header' class='clearfix'>
                            <p style='color: #606266;font-size: 15px'>{{ contact.info.data.description }}</p>
                            <p style='color: #909399;font-size: 10px;'><span>入群消息: </span>{{ contact.info.data.welcomeMessage }}</p>
                        </div>
                        <div v-if='!contact.info.isSystemChannel'>
                            <p>群成员列表 <span>{{ chatUi.currentMemberList.length }} 在线 {{ getOnlineCount }}</span>
                            </p>
                            <p style='margin-bottom: 1rem;'>
                                <el-input size='mini' clearable @focus='handleSearchMemberFocus'
                                          @clear='handleSearchMemberClear' @input='handleSearchMemberInput'
                                          v-model='chatUi.searchMemberKey'
                                          placeholder='请输入userId或用户名'></el-input>
                            </p>
                            <el-scrollbar :data-box='computeMemberBox' class='xcye' :style='{height: memberBoxHeight}'>
                                <div style='margin-bottom: 10px;' v-for='(item, index) in chatUi.currentMemberList'
                                     :key='index' class='infinite-list-item'>
                                    <el-popover
                                        placement='right'
                                        width='400'
                                        trigger='click'>
                                        <div>
                                            <el-form label-position='left' label-width='80px'>
                                                <el-form-item label='状态'>
                                                    <el-switch
                                                        @change='handleMemberBanStatus($event, item, contact.conversationId)'
                                                        v-model='item.status'
                                                        :active-value='1'
                                                        :inactive-value='0'
                                                        active-text='正常'
                                                        inactive-text='禁言'>
                                                    </el-switch>
                                                </el-form-item>
                                                <el-form-item label='角色'>
                                                    <el-tag size='mini' v-if='item.role === 0' type='success'>频道主
                                                    </el-tag>
                                                    <el-tag size='mini' v-if='item.role === 1'>管理者</el-tag>
                                                    <el-tag size='mini' v-if='item.role === 2' type='warning'>普通成员
                                                    </el-tag>
                                                    <el-tag size='mini' v-if='item.role === 3' type='danger'>游客
                                                    </el-tag>
                                                    <el-tag size='mini' v-if='item.role === 4' type='info'>机器人
                                                    </el-tag>
                                                </el-form-item>
                                                <el-form-item label='userId'>
                                                    <p>{{ item.userId }}</p>
                                                </el-form-item>
                                                <el-form-item label='加入时间'>
                                                    <p>{{ item.joinTime }}</p>
                                                </el-form-item>
                                                <el-form-item label='在线'>
                                                    <p>{{ item.onlineTime }}</p>
                                                </el-form-item>
                                                <el-form-item label='离线'>
                                                    <p>{{ item.offlineTime }}</p>
                                                </el-form-item>
                                                
                                                <el-form-item label='操作'>
                                                    <el-button size='mini' type='danger'
                                                               @click='handleRemoveMember(item, contact.conversationId)'>
                                                        删除
                                                    </el-button>
                                                    <el-button size='mini' type='success'
                                                               @click='sendPrivateMsg(item.userId)'>私信
                                                    </el-button>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                        <p slot='reference'><i
                                            :class='item.onlineTime ? "member-active": "member-offline"'
                                            class='el-icon-user-solid'
                                            style='padding-right: 5px'></i>{{ item.contact.name }}<i
                                            class='el-icon-turn-off-microphone' v-if='item.status === 0'
                                            style='float: right;color: #F56C6C'></i></p>
                                    </el-popover>
                                </div>
                            </el-scrollbar>
                        </div>
                    </el-card>
                </div>
            </template>
            <template #message-title='contact'>
                <span>{{ contact.displayName }}</span>
                <span style='margin-left: 10px' v-if='contact.info && !contact.info.isSystemChannel'>消息数 {{contact.latestContactData ? contact.latestContactData.count : 0}}</span>
            </template>
        </lemon-imui>
    </div>
</template>
<script>

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import { webSocketApi } from '@api/Im/websocket/websocket';
import { imChannelApi } from '@api/Im/ImChannelApi';
import { deepCopy } from '@/utils/object';
import { localStg } from '@/utils/storage/local';
import { message } from '@/utils/message';
import bus from '@/components/common/bus';
import { imMessageApi } from '@api/Im/ImMessageApi';
import { copyContent } from '@/utils/string/cottonPlugin';
import { imUserStatusApi } from '@api/Im/ImUserStatusApi';
import { imChannelMemberApi } from '@api/Im/ImChannelMemberApi';
import { notification } from '@/utils/notification';

export default {
    name: 'ImChat',
    components: {
        VueJsonPretty
    },
    data() {
        return {
            // 是否显示弹出层
            open: false,
            projectName: undefined,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'type asc',
                    'createTime desc'
                ],
                
                projectName: undefined
            },
            latestMsgQueryParam: {
                pageNum: 1,
                pageSize: 15
            },
            consumeMsg: {
                msgList: [],
                queryParam: {
                    cursorId: undefined,
                    messageSort: undefined,
                    conversationType: undefined,
                    conversationId: undefined,
                    pageNum: 1,
                    pageSize: 4
                },
                currentMsg: {},
                activeFriend: {},
                activeChannel: {},
                loadMsgStatus: false,
                loadMsgList: [],
                hasMore: false,
                loadLatestMsgListTime: undefined,
                currentContact: undefined,
                schedulePullMsgQueryParam: {
                    cursorId: undefined,
                    messageSort: 'asc',
                    conversationType: undefined,
                    conversationId: undefined,
                    pageNum: 1,
                    pageSize: 15
                }
            },
            projectInfoList: [],
            userOnlineStatusMap: new Map,
            userOnlineStatusList: [],
            queryOnlineParam: {
                total: 0,
                pageNum: 1,
                pageSize: 100,
                sortSqlList: [
                    'id asc'
                ]
            },
            channelList: [],
            chatList: [],
            chatMsgList: [],
            
            webSocketApi: undefined,
            channelMap: new Map,
            userIdMap: new Map,
            chatUi: {
                contextMenu: [
                    {
                        click: (e, instance, hide) => {
                            const { IMUI, message } = instance;
                            this.chatUi.currentSelectedMessage = message;
                            this.chatUi.selectTag = 1;
                            let obj = this;

                            let nodeMsgId = new Date().getTime();
                            const data = {
                                id: nodeMsgId,
                                type: 'event',
                                //使用 jsx 时 click必须使用箭头函数（使上下文停留在vue内）
                                content: (
                                    <div>
                                      <span>
                                        你正在修改消息{' '}
                                          <span
                                              v-show={message.type === 'text' || message.type === 'reply'}
                                              style='color:#333;cursor:pointer'
                                              content={message.content}
                                              on-click={e => {
                                                  obj.chatUi.currentSelectedMessage = undefined;
                                                  obj.chatUi.appendEventMessage = undefined;
                                                  obj.chatUi.selectTag = undefined;
                                                  IMUI.removeMessage(nodeMsgId);
                                                  IMUI.setEditorValue('');
                                                  IMUI.appendMessage(message, true);
                                              }}
                                          >
                                          取消修改
                                        </span>
                                      </span>
                                    </div>
                                ),

                                toContactId: message.toContactId,
                                sendTime: new Date().getTime()
                            }

                            IMUI.removeMessage(message.id);
                            IMUI.setEditorValue(message.content);
                            IMUI.appendMessage(data, true);
                            this.chatUi.appendEventMessage = data;
                            hide();
                        },
                        visible: instance => {
                            const { IMUI, message } = instance;
                            
                            if (message.sendMsg) {
                                return false;
                            }
                            
                            let contact = IMUI.currentContact;
                            let conversationType = contact.conversationType;
                            let conversationId = contact.conversationId;
                            if (conversationType === 'CHANNEL') {
                                let channel = this.channelMap.get(conversationId);
                                return channel.type !== 'SYSTEM';
                            } else {
                                return true;
                            }
                        },
                        text: '修改消息'
                    },
                    {
                        visible: instance => {
                            return instance.message.type === 'text' || instance.message.type === 'reply';
                        },
                        click: (e, instance, hide) => {
                            const { IMUI, message } = instance;
                            console.log(message);
                            copyContent(JSON.stringify(message.originalMessage));
                            hide();
                        },
                        text: '复制消息数据'
                    },
                    {
                        click: (e, instance, hide) => {
                            const { IMUI, message } = instance;
                            IMUI.setUserTag(message.fromUser);
                            hide();
                        },
                        text: '@TA',
                        visible: instance => {
                            const { IMUI, message } = instance;
                            let originalMessage = message.originalMessage
                            let contact = IMUI.currentContact;
                            let conversationType = contact.conversationType;
                            let conversationId = contact.conversationId;
                            if (conversationType === 'CHANNEL' && this.channelMap.get(conversationId) && this.channelMap.get(conversationId).type !== 'SYSTEM') {
                                return !originalMessage || originalMessage.senderCategory !== 1
                            }else {
                                return false
                            }
                        },
                    },
                    {
                        click: (e, instance, hide) => {
                            const { IMUI, message } = instance;
                            this.chatUi.currentSelectedMessage = message;
                            let obj = this;
                            let nodeMsgId = new Date().getTime();
                            const data = {
                                id: nodeMsgId,
                                type: 'event',
                                //使用 jsx 时 click必须使用箭头函数（使上下文停留在vue内）
                                content: (
                                    <div>
                                      <span>
                                        你正在回复消息{' '}
                                          <span
                                              v-show={message.type === 'text' || message.type === 'reply'}
                                              style='color:#333;cursor:pointer'
                                              content={message.content}
                                              on-click={e => {
                                                  obj.chatUi.replyMessage.message = undefined
                                                  obj.chatUi.replyMessage.eventNodeId = undefined
                                                  IMUI.removeMessage(nodeMsgId);
                                              }}
                                          >
                                          取消回复
                                        </span>
                                      </span>
                                    </div>
                                ),
                                
                                toContactId: message.toContactId,
                                sendTime: new Date().getTime()
                            }
                            
                            IMUI.appendMessage(data, true);
                            this.chatUi.replyMessage.message = message
                            this.chatUi.replyMessage.eventNodeId = nodeMsgId
                            hide();
                        },
                        visible: instance => {
                            const { IMUI, message } = instance;
                            
                            if (message.sendMsg) {
                                return false;
                            }
                            
                            let contact = IMUI.currentContact;
                            let conversationType = contact.conversationType;
                            let conversationId = contact.conversationId;
                            return !(conversationType === 'CHANNEL' && this.channelMap.get(conversationId)
                                && this.channelMap.get(conversationId).type === 'SYSTEM');
                        },
                        text: '回复',
                        icon: 'el-icon-position'
                    },
                    {
                        click: (e, instance, hide) => {
                            let projectName = this.queryParams.projectName;
                            const { IMUI, message } = instance;
                            this.$modal.confirm('是否删除"' + message.content + '"？').then(function() {
                                return imMessageApi.deleteData(message.originalMessage, projectName);
                            }).then((result) => {
                                if (result.code === 200) {
                                    this.getList();
                                    this.$modal.msgSuccess('删除成功');
                                    IMUI.removeMessage(message.id);
                                }
                            }).catch(() => {
                            });
                            hide();
                        },
                        icon: 'el-icon-delete-solid',
                        color: '#F56C6C',
                        text: '删除',
                        visible: instance => {
                            const { IMUI, message } = instance;
                            
                            if (message.sendMsg) {
                                return false;
                            }
                            
                            let contact = IMUI.currentContact;
                            let conversationType = contact.conversationType;
                            let conversationId = contact.conversationId;
                            if (conversationType === 'CHANNEL') {
                                let channel = this.channelMap.get(conversationId);
                                return channel.type !== 'SYSTEM';
                            } else {
                                return true;
                            }
                        }
                    },
                    {
                        click: (e, instance, hide) => {
                            let projectName = this.queryParams.projectName;
                            const { IMUI, message } = instance;
                            let userId = message.fromUser.id
                            let memberInfo = this.chatUi.currentMemberList.filter(t => t.userId === userId)[0]
                            let msg = memberInfo.status === 1 ? "禁言" : '取消禁言'
                            this.$modal.confirm('是否对该用户执行 ' + msg + ' 操作？').then(function() {
                                return imChannelMemberApi.muteMember({channelId: message.toContactId, userId: userId, status: memberInfo.status === 1 ? 0: 1}, projectName);
                            }).then((result) => {
                                if (result.code === 200) {
                                    this.$modal.msgSuccess(result.message);
                                    memberInfo.status = memberInfo.status === 1 ? 0 : 1
                                }
                            }).catch(() => {
                            });
                            hide();
                        },
                        icon: 'el-icon-microphone',
                        color: '#F56C6C',
                        text: '禁言或取消禁言',
                        visible: instance => {
                            const { IMUI, message } = instance;
                            
                            let userId = message.fromUser.id
                            if (userId === this.getCurrentUser.id) {
                                return false
                            }
                            
                            let contact = IMUI.currentContact;
                            let conversationId = contact.conversationId;
                            let conversationType = contact.conversationType;
                            if (conversationType === 'CHANNEL' && this.channelMap.get(conversationId).type !== 'SYSTEM' && this.chatUi.contactIdMapping[userId]) {
                                let originalMessage = message.originalMessage
                                return !originalMessage || originalMessage.senderCategory !== 1
                            }else {
                                return false
                            }
                        }
                    }
                ],
                contactContextMenu: [],
                contactIdMapping: {},
                currentSelectedMessage: undefined,
                
                // 1: 修改
                selectTag: undefined,
                
                sendMsgCountMap: new Map,
                
                appendEventMessage: undefined,
                
                currentMemberList: [],
                searchMemberKey: undefined,
                replyMessage: {
                    message: undefined,
                    eventNodeId: undefined
                }
            },
            dataList: [{ name: 1 }, { name: 2 }, { name: 3 }],
            memberBoxHeight: '310px',
            timer: {
                loadLatestContact: undefined,
                loadOnlineStatusList: undefined
            }
            
        };
    },
    computed: {
        getCurrentUser() {
            let userId = localStg.get('cotton_userid');
            let userName = localStg.get('cotton_username');
            return {
                id: userId,
                displayName: userName,
                avatar: 'https://cottongame.com/img/logo.png'
            };
        },
        getUsername() {
            return data => {
                let userId = data.userId;
                let userInfo = this.chatUi.contactIdMapping[userId];
                if (!userInfo) {
                    return '用户未找到';
                }
                return userInfo.name;
            }
        },
        computeMemberBox() {
            setTimeout(() => {
                this.$nextTick(() => {
                    let leftElement = document.querySelector('.lemon-vessel .lemon-vessel__left .lemon-messages');
                    if (leftElement) {
                        this.memberBoxHeight = leftElement.offsetHeight + 'px';
                    }
                });
            }, 500)
        },
        getOnlineCount() {
            return this.chatUi.currentMemberList.filter(t => t.onlineTime).length;
        }
    },
    created() {
        this.setInitValue();
        this.getList();
        
        if (this.queryParams.projectName) {
            bus.$emit('queriedImProjectName', this.queryParams.projectName);
        }
        
        bus.$on('selectedImProjectName', this.handleSelectedImProjectNameEvent);
    },
    mounted() {
        this.$refs.imUi.initEditorTools([]);
        this.$refs.imUi.setLastContentRender("reply", message => {
            return <span>回复</span>
        })
        this.$refs.imUi.messageViewToBottom()
        setTimeout(() => {
            this.timer.loadLatestContact = setInterval(() => {
                this.loadLatestMsg();
            }, 7000);
        }, 10000);
        
        setTimeout(() => {
            this.timer.loadOnlineStatusList = setInterval(() => {
                this.queryOnlineParam.pageNum = 0;
                this.userOnlineStatusList = [];
                console.log('正在拉取最新的用户在线状态列表');
                this.loadUserOnlineStatusList();
            }, 40000);
        }, 20000);
    },
    beforeDestroy() {
        bus.$off('selectedImProjectName', this.handleSelectedImProjectNameEvent);
        if (this.webSocketApi) {
            this.webSocketApi.close();
        }
        
        if (this.consumeMsg.loadLatestMsgListTime) {
            clearInterval(this.consumeMsg.loadLatestMsgListTime);
        }
        if (this.timer.loadOnlineStatusList) {
            clearInterval(this.timer.loadOnlineStatusList);
        }
        if (this.timer.loadLatestContact) {
            clearInterval(this.timer.loadLatestContact);
        }
    },
    methods: {
        loadUserOnlineStatusList() {
            imUserStatusApi.query(this.queryOnlineParam, this.queryParams.projectName).then(result => {
                if (result.code === 200) {
                    let dataList = result.data.result;
                    let pageNum = result.data.pageNum;
                    let totalPage = result.data.pages;
                    if (dataList) {
                        for (let i = 0; i < dataList.length; i++) {
                            let userInfo = dataList[i];
                            this.userOnlineStatusList.push(userInfo);
                            
                            let avatar;
                            if (userInfo.userId === this.getCurrentUser.id) {
                                avatar = this.getCurrentUser.avatar;
                            }
                            this.chatUi.contactIdMapping[userInfo.userId] = {
                                name: userInfo.username,
                                avatar: avatar,
                                isChannel: false,
                                data: userInfo,
                                exist: true
                            };
                            
                            this.userOnlineStatusMap.set(userInfo.userId, userInfo);
                            let contact = this.$refs.imUi.findContact(userInfo.userId);
                            if (!contact) {
                                this.$refs.imUi.appendContact({
                                    id: userInfo.userId,
                                    displayName: userInfo.username,
                                    avatar: undefined,
                                    index: userInfo.username.charAt(0).toUpperCase(),
                                    info: {
                                        exist: true
                                    },
                                    conversationType: 'PRIVATE_CHAT',
                                    conversationId: userInfo.userId,
                                    msgData: {
                                        count: 0
                                    }
                                });
                            }
                            
                            if (i === dataList.length - 1 && pageNum === totalPage) {
                                this.$refs.imUi.contacts.forEach(t => {
                                    if (t.conversationType === 'PRIVATE_CHAT' && this.userOnlineStatusMap.has(t.id)) {
                                        this.setContact(t);
                                    }
                                });
                                this.sortContacts();
                                
                                let atList = [];
                                // 初始化at
                                for (let j = 0; j < this.userOnlineStatusList.length; j++) {
                                    let userTemp = this.userOnlineStatusList[j];
                                    let atInfo = {
                                        id: userTemp.userId,
                                        displayName: userTemp.username,
                                        avatar: undefined
                                    };
                                    atList.push(atInfo);
                                }
                            }
                        }
                    }
                    
                    if (pageNum < totalPage) {
                        this.queryOnlineParam.pageNum = pageNum + 1;
                        this.loadUserOnlineStatusList();
                    } else {
                        this.queryOnlineParam.pageNum = 1;
                    }
                }
            });
        },
        sortContacts() {
            this.$refs.imUi.contacts.sort((a, b) => {
                if (!a.index) return;
                return a.index.localeCompare(b.index);
            });
        },
        handleSelectedImProjectNameEvent(t) {
            this.queryParams.projectName = t;
            this.$router.push(`/im/chat/${t}`);
            window.location.reload()
            this.setInitValue();
        },
        setInitValue() {
            this.queryParams.projectName = undefined;
            if (this.$route.params.projectName && this.$route.params.projectName.indexOf('undefined') === -1) {
                this.queryParams.projectName = this.$route.params.projectName;
            }
            if (!this.queryParams.projectName) {
                message.error('请选择项目!');
                return;
            }
            this.loadUserOnlineStatusList();
            this.initWebSocket();
            this.initData();
        },
        initData() {
            imChannelApi.query({ pageSize: 100000 }, this.queryParams.projectName).then(result => {
                if (result.code === 200) {
                    for (let i = 0; i < result.data.result.length; i++) {
                        let channel = result.data.result[i];
                        this.channelMap.set(channel.id, channel);
                        let type = channel.type;
                        let channelName = type === 'SYSTEM' ? '【系统】' + channel.name : channel.name;
                        let avatar
                        if (channel.logo) {
                            avatar = channel.logo
                        }else {
                            avatar = '/chat/group.png'
                        }
                        let mappingData = {
                            name: channelName,
                            avatar: avatar,
                            isChannel: true,
                            data: channel,
                            exist: true,
                            isSystemChannel: type === 'SYSTEM'
                        };
                        
                        this.chatUi.contactIdMapping[channel.id] = mappingData;
                        
                        if (!this.$refs.imUi.hasContact(channel.id)) {
                            let channelContact = {
                                id: channel.id,
                                displayName: channel.name,
                                avatar: '/chat/group.png',
                                index: '频道',
                                unread: 0,
                                msgData: {
                                    count: 0
                                },
                                info: mappingData,
                                conversationId: channel.id,
                                isGroup: true,
                                conversationType: 'CHANNEL'
                            };
                            this.$refs.imUi.appendContact(channelContact);
                        }
                        
                        if (i === result.data.result.length - 1) {
                            this.sortContacts();
                            let contacts = this.$refs.imUi.getContacts();
                            contacts.forEach(contact => {
                                if (this.channelMap.get(contact.id)) {
                                    this.setContact(contact);
                                }
                            });
                        }
                    }
                }
            });
        },
        getList() {
        
        },
        getLatestMsgList(param) {
            if (!param) {
                param = this.latestMsgQueryParam;
            }
            this.webSocketApi.send(param, 'QUERY_CONTACT_LIST');
        },
        handleContactList(data) {
            let dataList = data.data;
            if (!dataList || dataList.length <= 0) {
                return;
            }
            
            for (let i = 0; i < dataList.length; i++) {
                let msg = dataList[i];
                let id = msg.id;
                let hasContact = this.$refs.imUi.hasContact(id);
                
                if (hasContact) {
                    // 存在的话，unread值等于count - 当前的消息数
                    let findContact = this.$refs.imUi.findContact(id);
                    let unread = 0;
                    let lastMsgCount = findContact.lastMsgCount;
                    if (!lastMsgCount) {
                        // 用户尚未点击这个联系人 未读消息数便是查询到的消息数
                        unread = msg.count;
                    } else {
                        // 已经点击进了这个联系人 未读消息数等于当前的count - lastMsgCount
                        unread = msg.count - lastMsgCount;
                        if (unread < 0) {
                            // 说明unread已经被另一个定时获取消息的查询执行了修改
                            unread = 0;
                        }
                    }
                    
                    findContact.lastSendTime = this.convertDateToTimestamp(msg.lastSendTime);
                    findContact.lastContent = msg.lastContent;
                    findContact.msgData = msg;
                    findContact.unread = unread;
                    findContact.latestContactData = msg
                    findContact.lastSendTime = this.convertDateToTimestamp(msg.lastSendTime);
                    this.$refs.imUi.updateContact(deepCopy(findContact));
                } else {
                    let contactIdMapping = this.chatUi.contactIdMapping[id];
                    let isChannel = msg.messageCategory === 0;
                    
                    let displayName;
                    let avatar;
                    if (contactIdMapping) {
                        displayName = contactIdMapping.name;
                        avatar = contactIdMapping.avatar;
                    } else {
                        displayName = '正在查询';
                    }
                    
                    let contact = {
                        id: id,
                        displayName: displayName,
                        avatar: avatar,
                        index: isChannel ? '频道' : undefined,
                        unread: msg.count,
                        msgData: msg,
                        lastSendTime: this.convertDateToTimestamp(msg.lastSendTime),
                        lastContent: msg.lastContent,
                        info: this.chatUi.contactIdMapping[id],
                        conversationId: id,
                        isGroup: isChannel,
                        conversationType: isChannel ? 'CHANNEL' : 'PRIVATE_CHAT',
                        latestContactData: msg
                        
                    };
                    // 添加联系人
                    this.$refs.imUi.appendContact(contact);
                    
                    if (!contactIdMapping) {
                        this.setContact(contact);
                    }
                }
                
                if (i === dataList.length - 1) {
                    this.sortContacts();
                }
            }
        },
        handleQueryMsgList(data) {
            if (data.code === 200) {
                this.consumeMsg.loadMsgList = data.data.result;
                this.consumeMsg.hasMore = parseInt(data.data.pageNum) !== parseInt(data.data.pages);
            }
            this.consumeMsg.loadMsgStatus = true;
        },
        initWebSocket() {
            this.webSocketApi = webSocketApi();
            this.webSocketApi.registerEventListener(this.handleCommonError, 'ERROR');
            this.webSocketApi.registerEventListener(this.handleContactList, 'QUERY_CONTACT_LIST');
            this.webSocketApi.registerEventListener(this.handleQueryMsgList, 'QUERY_MESSAGE', 'contactQuery');
            this.webSocketApi.registerEventListener(this.handleSchedulePulledLatestMsgList, 'QUERY_MESSAGE', 'scheduleQuery');
            this.webSocketApi.registerEventListener(this.handleChannelMemberQuery, 'QUERY_MEMBER_AND_STATUS');
            this.webSocketApi.registerEventListener(this.handleWasAtNotice, 'AT_MEMBER');
            
            this.webSocketApi.open(this.queryParams.projectName).then(result => {
                // 开始拉取最新的
                this.getLatestMsgList();
            });
        },
        handleCommonError(data, event) {
        
        },
        loadLatestMsg() {
            this.getLatestMsgList({ pageSize: 15 });
        },
        convertDateToTimestamp(date) {
            return new Date(date).getTime();
        },
        handleEnterChat(msg) {
            this.consumeMsg.currentMsg = deepCopy(msg);
            
            let messageCategory = msg.messageCategory;
            if (messageCategory === 1) {
                this.consumeMsg.queryParam.conversationType = 'PRIVATE_CHAT';
            } else {
                this.consumeMsg.queryParam.conversationType = 'CHANNEL';
            }
            this.consumeMsg.queryParam.conversationId = msg.recipientId;
            
            // 查询消息列表
            this.webSocketApi.send(this.consumeMsg.queryParam, 'QUERY_MESSAGE');
        },
        
        handleChatMenuChange(name) {
        
        },
        handleChangeContact(contact, instance) {
            console.log(`当前的对话${contact.conversationId}`);
            
            this.$refs.imUi.setAtUserList([])
            this.chatUi.currentMemberList = [];
            this.consumeMsg.schedulePullMsgQueryParam.conversationId = contact.conversationId;
            this.consumeMsg.schedulePullMsgQueryParam.conversationType = contact.conversationType;
            this.consumeMsg.schedulePullMsgQueryParam.pageNum = 1;
            
            this.consumeMsg.queryParam.cursorId = undefined;
            instance.updateContact({
                id: contact.id,
                unread: 0,
                lastMsgCount: contact.msgData.count
            });
            this.consumeMsg.currentContact = contact;
            if (!this.consumeMsg.loadLatestMsgListTime) {
                this.consumeMsg.loadLatestMsgListTime = setInterval(() => {
                    this.executeScheduleLoadMsg();
                }, 7000);
            }
            
            if (contact.conversationType === 'CHANNEL' && !contact.info.isSystemChannel) {
                this.loadChannelMemberList(contact.id);
            }
        },
        executeScheduleLoadMsg() {
            let param = {
                cursorId: undefined,
                messageSort: 'asc',
                conversationType: this.consumeMsg.schedulePullMsgQueryParam.conversationType,
                conversationId: this.consumeMsg.schedulePullMsgQueryParam.conversationId,
                pageNum: 1,
                pageSize: 15
            };
            
            let currentMsgList = this.$refs.imUi.getCurrentMessages();
            if (currentMsgList && currentMsgList.length > 0) {
                param.cursorId = this.getHadSavedMsgId(currentMsgList, currentMsgList.length - 1);
                this.consumeMsg.schedulePullMsgQueryParam.cursorId = param.cursorId;
            }
            console.log(`正在拉取${this.consumeMsg.currentContact.conversationType}_${this.consumeMsg.currentContact.conversationId}的最新消息`);
            // 每隔7秒拉取最新的消息
            this.schedulePullLatestMsgList(param);
        },
        loadChannelMemberList(channelId) {
            let queryParam = {
                conversationId: channelId
            };
            this.webSocketApi.send(queryParam, 'QUERY_MEMBER_AND_STATUS');
        },
        handleChannelMemberQuery(data) {
            if (data.code === 200) {
                this.chatUi.currentMemberList = data.data;
                
                let atUserList = []
                for (let i = 0; i < this.chatUi.currentMemberList.length; i++) {
                    let memberInfo = this.chatUi.currentMemberList[i]
                    let contactMap = this.chatUi.contactIdMapping[memberInfo.userId];
                    if (!contactMap) {
                        contactMap = {
                            name: '用户不存在'
                        };
                    }else {
                        atUserList.push({
                            displayName: contactMap.name,
                            avatar: undefined,
                            id: memberInfo.userId
                        })
                    }
                    memberInfo.contact = contactMap;
                    
                    if (i === this.chatUi.currentMemberList.length - 1) {
                        this.$refs.imUi.setAtUserList(atUserList, true);
                    }
                }
            }
        },
        getHadSavedMsgId(currentMsgList, index) {
            let msg = currentMsgList[index];
            if (msg) {
                if (!msg.sendMsg && msg.type === 'text' || !msg.sendMsg && msg.type === 'reply') {
                    return msg.originalMessage.id;
                } else {
                    return this.getHadSavedMsgId(currentMsgList, index - 1);
                }
            } else {
                return undefined;
            }
        },
        packageMessage(message, contact) {
            let replyMessage = message.replyMessage
            let userInfo = this.userOnlineStatusMap.get(message.senderId);
            let currentUser = this.$refs.imUi.user;
            let avatar;
            if (message.senderId === currentUser.id) {
                avatar = currentUser.avatar;
            }
            let replyPackageMessage
            if (replyMessage) {
                replyPackageMessage = this.packageMessage(replyMessage, contact)
            }
            
            let displayName = userInfo ? userInfo.username : '用户不存在'
            if (message.senderCategory === 1) {
                displayName = displayName + "【内部】"
            }
            return {
                id: message.id,
                status: 'succeed',
                type: replyMessage ? 'reply' : 'text',
                sendTime: this.convertDateToTimestamp(message.createTime),
                content: message.content,
                fromUser: {
                    id: message.senderId,
                    displayName: displayName,
                    avatar: avatar
                },
                toContactId: contact.id,
                originalMessage: message,
                replyMessage: replyPackageMessage
            };
        },
        handlePullMessages(contact, next, instance) {
            let existStatus = contact.info.exist;
            if (!existStatus) {
                message.warning(`${contact.displayName} 已被删除, 正在浏览历史消息`);
            }
            
            this.consumeMsg.loadMsgList = [];
            this.consumeMsg.loadMsgStatus = false;
            
            this.consumeMsg.queryParam.conversationId = contact.conversationId;
            this.consumeMsg.queryParam.conversationType = contact.conversationType;
            this.consumeMsg.queryParam.messageSort = 'desc';
            
            let currentMsgList = this.$refs.imUi.getCurrentMessages();
            if (currentMsgList && currentMsgList.length > 0) {
                this.consumeMsg.queryParam.cursorId = currentMsgList[0].originalMessage.id;
            }
            
            this.webSocketApi.send(this.consumeMsg.queryParam, 'QUERY_MESSAGE', 'contactQuery');
            let time = setInterval(() => {
                if (this.consumeMsg.loadMsgStatus) {
                    clearInterval(time);
                    this.consumeMsg.loadMsgStatus = false;
                    if (this.consumeMsg.loadMsgList.length <= 0) {
                        next([], true);
                    } else {
                        let msgList = [];
                        for (let i = this.consumeMsg.loadMsgList.length - 1; i >= 0; i--) {
                            let msg = this.consumeMsg.loadMsgList[i];
                            let message = this.packageMessage(msg, contact);
                            msgList.push(message);
                            if (i === 0) {
                                next(msgList, !this.consumeMsg.hasMore);
                            }
                        }
                    }
                }
            }, 10);
        },
        handleMessageClick(event, key, message, instance) {
        },
        handleMenuAvatarClick(contact) {
        
        },
        handleMsgSend(inputMessage, next, file) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(inputMessage.content, 'text/html');
            let content = doc.body.textContent || '';
            
            let contact = this.$refs.imUi.currentContact;
            let atList = inputMessage.at;
            if (atList) {
                if (atList.length > 0 && !contact.isGroup) {
                    message.error('私聊无法执行@操作');
                    this.$refs.imUi.removeMessage(inputMessage.id);
                    next();
                    setTimeout(() => {
                        this.$refs.imUi.setEditorValue(content);
                    }, 1000);
                    return;
                }
                let isAtAll = atList.includes('isALL');
                if (isAtAll) {
                    atList = ['atAll'];
                }
            }
            
            let info = contact.info;
            let conversationType = contact.conversationType;
            if (!info.exist) {
                let errorMsg;
                if (conversationType === 'CHANNEL') {
                    errorMsg = '频道已被删除';
                } else {
                    errorMsg = '该用户不存在';
                }
                message.error(errorMsg);
                this.$refs.imUi.removeMessage(inputMessage.id);
                return;
            }
            
            if (conversationType === 'CHANNEL') {
                let channelData = info.data;
                if (channelData && channelData.type === 'SYSTEM') {
                    message.error('无法在此处发送系统消息');
                    this.$refs.imUi.removeMessage(inputMessage.id);
                    return;
                }
            }
            
            let currentSelectedMessage = this.chatUi.currentSelectedMessage;
            let selectTag = this.chatUi.selectTag;
            if (!selectTag) {
                // 普通发送消息
                inputMessage.sendMsg = true;
                inputMessage.originalMessage = {
                    content: content,
                    id: this.$refs.imUi.currentMessages[this.$refs.imUi.currentMessages.length - 1].id
                };
                
                let replyMessage = this.chatUi.replyMessage.message
                // 发送消息
                let data = {
                    conversationType: contact.conversationType,
                    conversationId: contact.conversationId,
                    replyMsgId: replyMessage ? replyMessage.id : undefined,
                    param: {
                        atMember: atList
                    },
                    content: content,
                    messageTemplateName: undefined
                };
                
                this.webSocketApi.send(data, 'SEND_MESSAGE');
                setTimeout(() => {
                    this.executeScheduleLoadMsg();
                    if (replyMessage) {
                        this.chatUi.replyMessage.message = undefined
                        this.chatUi.replyMessage.eventNodeId = undefined
                    }
                }, 1000);
                this.$refs.imUi.removeMessage(inputMessage.id);
                if (replyMessage) {
                    this.$refs.imUi.removeMessage(this.chatUi.replyMessage.eventNodeId);
                }
                next();
            } else if (selectTag === 1) {
                // 修改消息
                let originalMessage = currentSelectedMessage.originalMessage;
                originalMessage.content = content;
                
                imMessageApi.update(originalMessage, this.queryParams.projectName).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        // 修改成功
                        currentSelectedMessage.content = content;
                    }
                    this.$refs.imUi.removeMessage(inputMessage.id);
                    this.$refs.imUi.appendMessage(currentSelectedMessage, true);
                    this.$refs.imUi.removeMessage(this.chatUi.appendEventMessage.id);
                    this.chatUi.selectTag = undefined;
                    this.chatUi.appendEventMessage = undefined;
                    this.chatUi.currentSelectedMessage = undefined;
                    next();
                });
            }
        },
        setContact(contact) {
            if (!contact) {
                return;
            }
            let id = contact.id;
            let info = contact.info;
            let isChannel = contact.conversationType === 'CHANNEL';
            
            let contactMappingData = this.chatUi.contactIdMapping[id];
            if (contactMappingData) {
                contact.info = contactMappingData;
                contact.displayName = contactMappingData.name;
                contact.avatar = contactMappingData.avatar;
                this.$refs.imUi.updateContact(deepCopy(contact));
            } else {
                if (!isChannel && this.userOnlineStatusMap.size !== 0) {
                    // 用户不存在
                    contactMappingData = {
                        name: '用户不存在',
                        avatar: undefined,
                        isChannel: false,
                        data: {
                            userId: id
                        },
                        exist: false
                    }
                } else if (isChannel && this.channelMap.size !== 0) {
                    // 不存在
                    let channelInfo = {
                        name: '频道不存在',
                        id: id,
                        logo: '/chat/group.png'
                    };
                    contactMappingData = {
                        name: channelInfo.name,
                        avatar: channelInfo.logo,
                        isChannel: true,
                        data: channelInfo,
                        exist: false
                    };
                }
                
                if (contactMappingData) {
                    contact.info = contactMappingData;
                    contact.displayName = contactMappingData.name;
                    contact.avatar = contactMappingData.avatar;
                    this.$refs.imUi.updateContact(deepCopy(contact));
                }
            }
        },
        schedulePullLatestMsgList(param) {
            this.webSocketApi.send(param, 'QUERY_MESSAGE', 'scheduleQuery');
        },
        handleSchedulePulledLatestMsgList(data) {
            if (data.code !== 200) {
                return;
            }
            let msgList = data.data.result;
            let currentPageNum = parseInt(data.data.pageNum);
            let totalPage = parseInt(data.data.pages);
            
            if (!msgList || msgList.length === 0) {
                return;
            }
            
            let recipientId = msgList[0].recipientId;
            let contact = this.$refs.imUi.findContact(recipientId);
            
            // 修改unread
            contact.lastMsgCount = contact.lastMsgCount + msgList.length;
            contact.unread = 0;
            this.$refs.imUi.updateContact(deepCopy(contact));
            
            // 添加到列表中
            msgList.forEach(item => {
                let packageMessage = this.packageMessage(item, contact);
                this.$refs.imUi.appendMessage(packageMessage, false);
                
            });
            
            if (recipientId === this.$refs.imUi.currentContact.id && currentPageNum < totalPage) {
                this.consumeMsg.schedulePullMsgQueryParam.pageNum = currentPageNum + 1;
                this.schedulePullLatestMsgList(this.consumeMsg.schedulePullMsgQueryParam);
            }
        },
        changeDrawer(contact, instance) {
            instance.changeDrawer({
                //width: 240,
                //height: "90%",
                //offsetX:0 ,
                //offsetY: ,
                //position: "center",
                // inside: true,
                // offsetX: -280,
                // offsetY: -100,
                render: () => {
                    return (
                        <div class='drawer-content'>
                            <p>
                                <b>自定义抽屉</b>
                            </p>
                            <p>{contact.displayName}</p>
                        </div>
                    );
                }
            });
        },
        handleRemoveMember(item, channelId) {
            let projectName = this.queryParams.projectName;
            this.$modal.confirm(`是否从频道${channelId}中移除成员${item.contact.name}`).then(function() {
                return imChannelMemberApi.memberExit({ channelId: channelId, userId: item.userId }, projectName);
            }).then((result) => {
                if (result.code === 200) {
                    this.$modal.msgSuccess('移除成功');
                    this.chatUi.currentMemberList.splice(this.chatUi.currentMemberList.indexOf(item), 1);
                }
            }).catch(() => {
            });
        },
        handleMemberBanStatus(value, item, channelId) {
            let projectName = this.queryParams.projectName;
            this.$modal.confirm(`是否对${item.contact.name} 执行${value === 1 ? '取消禁言' : '禁言'}操作`).then(function() {
                return imChannelMemberApi.muteMember({
                    channelId: channelId,
                    userId: item.userId,
                    status: value
                }, projectName);
            }).then((result) => {
                if (result.code === 200) {
                    this.$modal.msgSuccess('操作成功');
                } else {
                }
            }).catch(() => {
            });
        },
        handleSearchMemberFocus() {
            this.chatUi.backMemberList = this.chatUi.currentMemberList;
        },
        handleSearchMemberClear() {
            this.chatUi.currentMemberList = this.chatUi.backMemberList;
        },
        handleSearchMemberInput(value) {
            this.chatUi.currentMemberList = this.chatUi.backMemberList.filter(t => {
                return t.userId.includes(value) || t.contact.name.includes(value);
            });
        },
        sendPrivateMsg(userId) {
            this.$refs.imUi.changeContact(userId);
        },
        handleWasAtNotice(result) {
            if (result.code === 200 && result.data) {
                let data = result.data
                let msgContent = data.msgContent
                let senderId = data.senderId
                let channelId = data.conversationId
                let contactMappingData = this.chatUi.contactIdMapping[senderId];
                if (!contactMappingData) {
                    contactMappingData = {
                        name: '用户不存在',
                        exist: false
                    }
                }
                notification.success(`用户<span style='color: #409EFF'>${contactMappingData.name}</span>在消息<span style='color: #409EFF'>${msgContent} </span>中@了你, 点击进入对话`, '@通知', () => {
                    let contact = this.$refs.imUi.findContact(channelId);
                    if (!contact) {
                        message.error('对话不存在 进入聊天失败')
                    }else {
                        this.$refs.imUi.changeContact(contact.id)
                    }
                }, 7000)
            }
        }
    }
};
</script>
<style lang='css'>

.member-detail {
    font-size: 10px;
    color: #909399;
}

.member-active {
    color: #F56C6C;
}

.member-offline {
    color: #909399;
}

.lemon-editor__inner {
    background-color: rgba(235, 238, 245, 0.53);
    padding-top: 2px;
}
</style>
